import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

class TOSBar extends React.Component {
  static propTypes = {
    fixed: PropTypes.bool,
  };

  render() {
    return (
      <div className={`tos-bar ${this.props.fixed ? 'tos-bar-fixed' : ''}`}>
        <div className='container'>
          <div className='pull-right'>
            <a href='#privacy-policy'><FormattedMessage id="general.privacy.policy" /></a> &nbsp; | &nbsp; <a href='#terms-of-service'><FormattedMessage id="general.terms.use" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default TOSBar;
